export class NetworkClassificationDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkClassification",
            "baseName": "networkClassification",
            "type": "NetworkClassification",
            "format": ""
        },
        {
            "name": "reasons",
            "baseName": "reasons",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "unknownReasons",
            "baseName": "unknownReasons",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NetworkClassificationDetails.attributeTypeMap;
    }
    constructor() {
    }
}
